import { normalizeClientSearchQuery } from "./clientSearch";

export { normalizeClientSearchQuery };

const CLIENT_LIST_SORT_FIELDS = new Set([
  "id",
  "first_name",
  "last_name",
  "email",
  "phone_number",
]);

const validPage = (value) => {
  const page = Number(value);
  return Number.isInteger(page) && page > 0 ? page : null;
};

const pageFromLegacyUrl = (url) => {
  if (typeof url !== "string" || !url) return null;

  try {
    return validPage(new URL(url, "https://client-list.invalid").searchParams.get("page"));
  } catch (_error) {
    return null;
  }
};

const errorMessage = (value) => {
  if (typeof value === "string") return value;
  if (value && value.error && typeof value.error.message === "string") return value.error.message;
  if (value && typeof value.message === "string") return value.message;
  return "Unable to load clients.";
};

export const buildClientListRequest = (values = {}) => {
  const page = validPage(values.page) || pageFromLegacyUrl(values.next_page_url);
  const limit = validPage(values.limit);
  const normalizedQuery = normalizeClientSearchQuery(values.q);
  const params = new URLSearchParams();

  if (page) params.set("page", String(page));
  if (limit) params.set("limit", String(limit));
  if (normalizedQuery) params.set("q", normalizedQuery);
  if (values.sort && typeof values.sort === "object") {
    Object.entries(values.sort).forEach(([field, direction]) => {
      if (CLIENT_LIST_SORT_FIELDS.has(field) && (direction === "asc" || direction === "desc")) {
        params.set(`sort[${field}]`, direction);
      }
    });
  }

  const clientId = validPage(values.id);
  const body = clientId ? { id: clientId } : { pagination: true };
  if (!clientId && normalizedQuery) {
    body.apicall = "suggetion";
  }

  const query = params.toString();
  return {
    url: `afterlogin/client/view${query ? `?${query}` : ""}`,
    body,
  };
};

export const normalizeClientListResponse = (response) => {
  if (!Array.isArray(response) && response && Array.isArray(response.data)) {
    const currentPage = validPage(response.current_page) || 1;
    const lastPage = validPage(response.last_page) || currentPage;
    const nextPage = response.next_page_url !== undefined
      ? response.next_page_url
      : (currentPage < lastPage ? `afterlogin/client/view?page=${currentPage + 1}` : null);
    const previousPage = response.prev_page_url !== undefined
      ? response.prev_page_url
      : (currentPage > 1 ? `afterlogin/client/view?page=${currentPage - 1}` : null);

    return {
      ...response,
      next_page_url: nextPage,
      prev_page_url: previousPage,
    };
  }

  const clients = Array.isArray(response) ? response : [response];
  return {
    current_page: 1,
    data: clients,
    last_page: 1,
    next_page_url: null,
    per_page: clients.length,
    prev_page_url: null,
    total: clients.length,
  };
};

export const mergeClientListPage = (previous, next) => {
  const previousPage = previous && Number(previous.current_page);
  const nextPage = next && Number(next.current_page);
  const previousClients = previous && Array.isArray(previous.data) ? previous.data : [];
  const nextClients = next && Array.isArray(next.data) ? next.data : [];

  return previousPage && nextPage && nextPage > previousPage
    ? { ...next, data: [...previousClients, ...nextClients] }
    : next;
};

export const clientListErrorFromAction = (action) => {
  const payload = action && action.payload;
  const fallback = action && action.error;
  const value = payload || fallback || {};

  return {
    status: value.status || null,
    message: errorMessage(value.message || value),
  };
};
